import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatMoney, formatMoneyShorten, remove255 } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { FaRegCommentDots } from "react-icons/fa6";
import { STR_CART_IS_EMPTY, STR_CLICK_TO_VIEW_COMMENTS, STR_COULD_NOT_FETCH_DATA, STR_ENTER_PAYPHONE, STR_ENTER_PHONE_NUMBER_FOR_PAYMENT, STR_GO_BACK, STR_ORDER_NOTES, STR_ORDER_NOTES_HELP_TEXT, STR_OVERALL_COST, STR_PAY_TO_PLACE_ORDER, STR_PAY_WITH_CARD, STR_PAY_WITH_MOBILE, STR_PHARMACY, STR_PHARMACY_ORDER_FINAL_TEXT_CARD, STR_PHARMACY_ORDER_FINAL_TEXT_PHONE, STR_PLACE_ORDER, STR_PLEASE_SELECT_ITEMS_TO_BUY, STR_PROVIDE_YOUR_ADDRESS, STR_SELECT_PAYMENT_METHOD, STR_SHIPPING_COST, STR_TOTAL_ORDER_PRICE, STR_TRANSACTION_FEES, STR_WRITE_YOUR_COMMENT, STR_YOUR_CART } from "../Strings";
import LoginView from '../views/LoginView';
import NapaAddressPicker from "../ones/NapaAddressPicker";
import OnePharmacyItemSimple from "../ones/OnePharmacyItemSimple";
import { MdCheckCircle } from "react-icons/md";
import MobileInterface from "../MobileInterface";


export default function View({ }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [itemsData, setItemsData] = useState(null);


	const [opSuccessful, setOpSuccessful] = useState(false);
	const [loading, setLoading] = useState(false);


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getItemsData(),
		]);
		setReady(true);
	}

	
	async function getItemsData() {
		
		await callApi(
			"get-pharmacy-items-data", 
			{ 
				items: JSON.stringify(appContext.cart)
			}
		).then(response => {
			if (response.status === 1) {
				setItemsData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
		
	}

	

	async function placeOrder() {
		appContext.navTo({
			item: 'bottom-view',
			subItem: 'pharmacy-cart-checkout',
		})
	}

	useEffect(() => {
		if(itemsData) {
			
		}
	}, [itemsData])

	useEffect(() => {
		init();
	}, [ appContext.cart ])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if(appContext.auth && appContext.currentUserData) {
		if (ready && itemsData) {
			return (
				<div className="container">
					<h6 className="mSectionTitle">
						{STR_YOUR_CART[appContext.language]}
					</h6>


					<div className="row">			
						<div className="col-md-12 mt-4 mb-4">
							{
								(itemsData && itemsData.length > 0) ?
								itemsData.map((item, i) => {
									return (
										<OnePharmacyItemSimple index={i} key={i} data={item}/>
									)
								})
								:
								<h6
									style={{
										fontSize: "16px"
									}}
								>
									{STR_CART_IS_EMPTY[appContext.language]}
								</h6>
							}
						</div>

						

						<div className="col-md-12 mb-4 mt-2">
							{
								(itemsData && itemsData.length > 0) ?
								<button
									className="btn btn-block btn-rounded btn-padded btn-primary mb-4"
									onClick={placeOrder}
								>
									{STR_PLACE_ORDER[appContext.language]}
								</button>
								:
								<button
									className="btn btn-block btn-rounded btn-padded btn-primary mb-4"
									onClick={() => appContext.navTo({ item: 'pharmacy' })}
								>
									{STR_PHARMACY[appContext.language]}
								</button>
							}
							
						</div>

					</div>
						
				</div>
			)
		} else {
			return (
				<div
					className="mSupportLoading container"
				>
					{getInlineLoader()}
				</div>
			);
		}
	} else {
		return (
			<LoginView/>
		)
	}


}